(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["la-firma-mobile-overrides"]) return;
  try {
    
  (function () {
    const MOBILE_QUERY = '(max-width: 749px)';

    function relocateItem({ sectionSelector, itemSelector, targetSelector, relocatedClass, restorePosition }) {
      const section = document.querySelector(sectionSelector);
      const target = document.querySelector(targetSelector);
      if (!section || !target) return;

      const grid = section.querySelector('.la-firma-dos-imagenes__grid');
      const item = section.querySelector(itemSelector);
      if (!grid || !item) return;

      const isMobile = window.matchMedia(MOBILE_QUERY).matches;

      if (isMobile) {
        item.classList.add(relocatedClass);
        target.insertAdjacentElement('afterend', item);
      } else {
        item.classList.remove(relocatedClass);
        if (restorePosition === 'first') {
          grid.prepend(item);
        } else {
          grid.appendChild(item);
        }
      }
    }

    function relocateMobileImages() {
      relocateItem({
        sectionSelector: '.la-firma-dos-imagenes:has(.la-firma-dos-imagenes__title)',
        itemSelector: '.la-firma-dos-imagenes__item--right',
        targetSelector: '[data-la-firma-mobile-image-target]',
        relocatedClass: 'la-firma-dos-imagenes__item--relocated',
        restorePosition: 'last',
      });

      relocateItem({
        sectionSelector: '.la-firma-dos-imagenes:not(:has(.la-firma-dos-imagenes__title))',
        itemSelector: '.la-firma-dos-imagenes__item--left',
        targetSelector: '[data-la-firma-mobile-image-equipo-target]',
        relocatedClass: 'la-firma-dos-imagenes__item--relocated',
        restorePosition: 'first',
      });
    }

    relocateMobileImages();
    window.addEventListener('resize', relocateMobileImages);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
